import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { endpoints, type SaveNotificationPreferencesBody } from './api';

/** Inbox hooks. */

export function useNotifications() {
    return useQuery({
        queryKey: ['notifications'],
        queryFn: () => endpoints.notifications(),
        // The inbox is what tells a seller a connection broke; a stale one defeats
        // the point.
        refetchInterval: 60_000,
    });
}

export function useMarkNotificationRead() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => endpoints.markNotificationRead(id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
    });
}

export function useMarkAllNotificationsRead() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => endpoints.markAllNotificationsRead(),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
    });
}

/**
 * Which inbox entries also reach the signed-in person's e-mail, in the chosen
 * company. Their own choice, so a session-only write: any member may make it,
 * and the API offers only the types their role reads.
 */
export function useNotificationPreferences() {
    return useQuery({ queryKey: ['notification-preferences'], queryFn: () => endpoints.notificationPreferences() });
}

export function useSaveNotificationPreferences() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: SaveNotificationPreferencesBody) => endpoints.saveNotificationPreferences(body),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notification-preferences'] }),
    });
}
